// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Conteneur principal aligné sur assistance-container */
.ticket-container {
  width: 100%;
  padding: 2rem 2rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin: 0 auto;
}

/* Wrapper interne pour le contenu de la page */
.ticket-page {
  display: flex;
  flex-direction: column;
  gap: 1.75rem;
}

.ticket-page__header {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.ticket-page__breadcrumb {
  margin: 0;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #9a3412;
  font-weight: 600;
}

.ticket-page__subtitle {
  margin: 0;
  font-size: 0.95rem;
  color: #5b5b5b;
}

/* Layout deux colonnes comme dans Assistance (flex) */
.ticket-layout {
  display: flex;
  gap: 2rem;
  align-items: flex-start;
}

.ticket-layout__column {
  display: flex;
  flex-direction: column;
  gap: 1.75rem;
}

.ticket-layout__column--info {
  flex: 0 0 30%;
  max-width: 30%;
}

.ticket-layout__column--chat {
  flex: 1 1;
  max-width: 70%;
}

.ticket-card {
  background: #ffffff;
  border: 1px solid #f3f3f3;
  border-radius: 1.1rem;
  padding: 1.4rem 1.4rem 1.55rem;
  box-shadow: 0 4px 18px -4px rgba(0, 0, 0, 0.08),
    0 2px 6px -2px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
  position: relative;
  overflow: hidden;
}

.ticket-card h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #7c2d12;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.ticket-details {
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
}

.ticket-detail {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: flex-start;
}

.ticket-detail .label {
  min-width: 140px;
  font-weight: 600;
  color: #9a3412;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.55px;
  line-height: 1.25;
}

.ticket-detail .value {
  font-size: 1.5rem;
  color: #222;
  line-height: 1.35;
  font-weight: 500;
}

.ticket-detail--description .value {
  white-space: normal;
}

.value--multiline span {
  display: block;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  padding: 0.8rem 0.6rem;
  border-radius: 0.6rem;
  font-size: 1.25rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  background: #ffedd5;
  color: #c2410c;
  border: 1px solid #fdba74;
}

.status-pill--accent {
  background: linear-gradient(135deg, #fdba74, #fb923c);
  color: #7c2d12;
  border: none;
}

.ticket-card--chat {
  min-height: 420px;
}

p.error-message {
  margin: 0;
  font-size: 0.8rem;
  color: #dc2626;
  background: #fee2e2;
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
}

@media screen and (max-width: 980px) {
  .ticket-container {
    padding: 2rem 1.5rem;
  }

  .ticket-layout {
    flex-direction: column;
  }

  .ticket-layout__column--info,
  .ticket-layout__column--chat {
    flex: 1 1 auto;
    max-width: 100%;
  }

  .ticket-card--chat {
    min-height: 360px;
  }
}

@media screen and (max-width: 600px) {
  .ticket-container {
    padding: 1.5rem 1.2rem 2.5rem;
  }
  .ticket-card {
    padding: 1.1rem 1.1rem 1.25rem;
  }
  .ticket-detail .label {
    min-width: 110px;
    font-size: 0.85rem;
  }
  .ticket-detail .value {
    font-size: 1rem;
    line-height: 1.3;
    font-weight: 500;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Ticket/Ticket.css"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,8BAA8B;EAC9B;sCACoC;EACpC,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;AACF","sourcesContent":["/* Conteneur principal aligné sur assistance-container */\n.ticket-container {\n  width: 100%;\n  padding: 2rem 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  margin: 0 auto;\n}\n\n/* Wrapper interne pour le contenu de la page */\n.ticket-page {\n  display: flex;\n  flex-direction: column;\n  gap: 1.75rem;\n}\n\n.ticket-page__header {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.ticket-page__breadcrumb {\n  margin: 0;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #9a3412;\n  font-weight: 600;\n}\n\n.ticket-page__subtitle {\n  margin: 0;\n  font-size: 0.95rem;\n  color: #5b5b5b;\n}\n\n/* Layout deux colonnes comme dans Assistance (flex) */\n.ticket-layout {\n  display: flex;\n  gap: 2rem;\n  align-items: flex-start;\n}\n\n.ticket-layout__column {\n  display: flex;\n  flex-direction: column;\n  gap: 1.75rem;\n}\n\n.ticket-layout__column--info {\n  flex: 0 0 30%;\n  max-width: 30%;\n}\n\n.ticket-layout__column--chat {\n  flex: 1;\n  max-width: 70%;\n}\n\n.ticket-card {\n  background: #ffffff;\n  border: 1px solid #f3f3f3;\n  border-radius: 1.1rem;\n  padding: 1.4rem 1.4rem 1.55rem;\n  box-shadow: 0 4px 18px -4px rgba(0, 0, 0, 0.08),\n    0 2px 6px -2px rgba(0, 0, 0, 0.05);\n  display: flex;\n  flex-direction: column;\n  gap: 1.1rem;\n  position: relative;\n  overflow: hidden;\n}\n\n.ticket-card h3 {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #7c2d12;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.ticket-details {\n  display: flex;\n  flex-direction: column;\n  gap: 1.1rem;\n}\n\n.ticket-detail {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  align-items: flex-start;\n}\n\n.ticket-detail .label {\n  min-width: 140px;\n  font-weight: 600;\n  color: #9a3412;\n  font-size: 1rem;\n  text-transform: uppercase;\n  letter-spacing: 0.55px;\n  line-height: 1.25;\n}\n\n.ticket-detail .value {\n  font-size: 1.5rem;\n  color: #222;\n  line-height: 1.35;\n  font-weight: 500;\n}\n\n.ticket-detail--description .value {\n  white-space: normal;\n}\n\n.value--multiline span {\n  display: block;\n}\n\n.status-pill {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.8rem 0.6rem;\n  border-radius: 0.6rem;\n  font-size: 1.25rem;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  background: #ffedd5;\n  color: #c2410c;\n  border: 1px solid #fdba74;\n}\n\n.status-pill--accent {\n  background: linear-gradient(135deg, #fdba74, #fb923c);\n  color: #7c2d12;\n  border: none;\n}\n\n.ticket-card--chat {\n  min-height: 420px;\n}\n\np.error-message {\n  margin: 0;\n  font-size: 0.8rem;\n  color: #dc2626;\n  background: #fee2e2;\n  padding: 0.5rem 0.75rem;\n  border-radius: 0.5rem;\n}\n\n@media screen and (max-width: 980px) {\n  .ticket-container {\n    padding: 2rem 1.5rem;\n  }\n\n  .ticket-layout {\n    flex-direction: column;\n  }\n\n  .ticket-layout__column--info,\n  .ticket-layout__column--chat {\n    flex: 1 1 auto;\n    max-width: 100%;\n  }\n\n  .ticket-card--chat {\n    min-height: 360px;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .ticket-container {\n    padding: 1.5rem 1.2rem 2.5rem;\n  }\n  .ticket-card {\n    padding: 1.1rem 1.1rem 1.25rem;\n  }\n  .ticket-detail .label {\n    min-width: 110px;\n    font-size: 0.85rem;\n  }\n  .ticket-detail .value {\n    font-size: 1rem;\n    line-height: 1.3;\n    font-weight: 500;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
